import { render } from "./AdminWrapper.vue?vue&type=template&id=43cf34e7&scoped=true&lang=pug"
import script from "./AdminWrapper.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminWrapper.vue?vue&type=script&setup=true&lang=js"

import "./AdminWrapper.vue?vue&type=style&index=0&id=43cf34e7&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43cf34e7"]])

export default __exports__